/**
 * The spacing scale, as the step number on --space-*. Layout components take
 * one of these instead of a raw length, so a page cannot invent a gap.
 */
export type Space = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 10 | 12 | 16;

export function classes(...parts: Array<string | false | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
